var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Who Pays Title?"}},[_c('buyer-seller-split',{attrs:{"field":"title_who_pays","value":_vm.commercial.title_who_pays,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }